import { useMutation } from "react-query";
import downloadAuditCSV from "../services/downloadAuditCSV";

function useDownloadAuditCSV() {
  return useMutation(["download-audit-csv"], downloadAuditCSV);
}

export default useDownloadAuditCSV;
